import NotificationModal from "./notification-modal.component";

export default NotificationModal;
